import { Box, Paper, Typography, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { Link as RouterLink, type To } from 'react-router-dom';

export interface StatCardProps {
  icon: ReactNode;
  value: number | string;
  label: string;
  color: string;
  to: To;
}

export const StatCard = ({ icon, value, label, color, to }: StatCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      component={RouterLink}
      to={to}
      sx={{
        p: 2.5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderLeft: '5px solid',
        borderColor: theme.palette.primary.main,
        textDecoration: 'none',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: theme.palette.grey[50],
        },
        // Paper's elevation shadow would otherwise replace the ring's halo.
        '&:focus-visible': theme.mixins.focusRing,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          mb: 1,
        }}
      >
        <Box
          sx={{
            color,
            display: 'flex',
            '& svg': {
              fontSize: 28,
            },
          }}
        >
          {icon}
        </Box>
        <Typography component="h2" variant="h5" fontWeight={500} color="text.secondary">
          {label}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: 40, fontWeight: 600, lineHeight: 1.2 }}>{value}</Typography>
    </Paper>
  );
};
